module.exports = __webpack_public_path__ + "img/100.24b05714.png";